import {Component, OnInit} from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-christmas-tournaments',
  templateUrl: './christmas-tournaments.component.html',
  styleUrls: ['./christmas-tournaments.component.css']
})
export class ChristmasTournamentsComponent implements OnInit {

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }

  changeRoute(param) {
    console.log(param)
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('christmas', 1, param).subscribe(res => {
      console.log(res)
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data:[]});
      this.eventService.loadEventTournaments = false;
    })
  }

}
